import React, {forwardRef} from 'react'
import FJToolbarIconButton from './FJToolbarIconButton'

import './FJBGColorBtn.less'
import FJLocalStore from "../../../store/FJLocalStore";

const FJBGColorBtn = forwardRef((props, ref) => {
  let {disabled, active, onClick, color, style} = props;
  return (
    <div style={style}
         tooltip={FJLocalStore._('background-color')}
         className='u-tooltip-bottom c-bgColor-btn'
         ref={ref}
    >
      <FJToolbarIconButton disabled={disabled}
                           active={active}
                           onClick={onClick}
                           icon={
                             <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                  width="20px" height="20px" viewBox="0 0 20 20">
                               <polygon style={{fill: color}} points="1.167,10.417 14.833,10.25 8.229,17.25 "/>
                               <path fill="#FFFFFF" d="M13.593,9.286l-4.55-4.55l-0.03,0.03L8.098,3.85L2.663,9.285L13.593,9.286L13.593,9.286z
	 M13.337,11.285H2.922c1.82,1.822,5.202,5.206,5.202,5.206C8.126,16.493,11.516,13.107,13.337,11.285z M6.83,2.583L5.793,1.546
	c-0.352-0.352-0.352-0.922,0.006-1.28c0.355-0.355,0.933-0.353,1.28-0.006l1.037,1.038l0.012-0.012l7.456,7.457
	c0.782,0.782,0.781,2.051,0.004,2.827l-6.189,6.188c-0.702,0.702-1.839,0.702-2.542,0l-6.33-6.328c-0.702-0.703-0.703-1.841,0-2.542
	L6.83,2.583z M16.5,19.285c-1.408,0-2.5-0.982-2.5-2.436c0-0.502,0.199-1.054,0.55-1.709c0.114-0.215,0.243-0.438,0.384-0.662
	c0.187-0.297,0.381-0.59,0.578-0.867c0.119-0.166,0.213-0.293,0.268-0.365l0.738-0.961l0.715,0.979
	c0.057,0.074,0.146,0.204,0.267,0.375c0.194,0.285,0.392,0.584,0.571,0.885c0.113,0.187,0.221,0.365,0.314,0.541
	C18.779,15.782,19,16.348,19,16.85C19,18.229,17.879,19.285,16.5,19.285z M16.477,15.447c-0.121,0.193-0.229,0.381-0.324,0.557
	c-0.217,0.408-0.334,0.73-0.334,0.846c0,0.396,0.236,0.609,0.684,0.609c0.396,0,0.684-0.268,0.684-0.609
	c0-0.09-0.143-0.451-0.392-0.904c-0.081-0.146-0.173-0.305-0.271-0.467c-0.01-0.019-0.021-0.035-0.031-0.053
	C16.484,15.434,16.48,15.439,16.477,15.447z"/>
                             </svg>
                           } />
    </div>
  );
});

export default FJBGColorBtn;


